<template>
    <!-- 智能换汇  -->
    <sub-page :title="title" :subtitle="subtitle" :description="description" :button-text="buttonText" :bg="bg"
        :right-bg="rightBg" :right-bg2="rightBg2" :partition="[6, 5]" :imgpar="[2, 1]" />
</template>

<script>
import SubPage from '@/views/components/SubPage.vue'
export default {
    name: 'exchange',
    components: {
        SubPage
    },
    data() {
        return {
            rightBg: "/img/pay/0--38.png",
            rightBg2: "/img/pay/0--37.png",
            bg: "/img/pay/0--36.png",
        }
    },
    computed: {
        title() {
            return this.$t('exchange.title');
        },
        subtitle() {
            return this.$t('exchange.subtitle');
        },
        description() {
            return [this.$t('exchange.description1'),
            this.$t('exchange.description2'),
            this.$t('exchange.description3'),
            this.$t('exchange.description4'),
            this.$t('exchange.description5')];
        },
        buttonText() {
            return this.$t('common.buttonText');
        },
    }
}
</script>